<template>
  <VRow>
    <VCol cols="12">
      <VRow justify="center" no-gutters class="mb-6">
        <VCol
          cols="12"
          sm="10"
          md="6"
          lg="5"
        >
          <div class="title mb-md-5 mb-4 mt-5 text-center">
            {{ $t('holder') }}
          </div>
          <UserInfoForm :user="user" />
        </VCol>
      </VRow>

      <VRow justify="center" no-gutters class="mb-6 mb-md-12">
        <VCol
          cols="12"
          sm="10"
          md="6"
          lg="5"
        >
          <div class="title mb-md-5 mb-4 mt-5 text-center">
            {{ $t('settings') }}
          </div>
          <UserSettingsForm />
        </VCol>
      </VRow>

      <VRow justify="center" no-gutters class="mb-6 mb-md-12">
        <VCol
          cols="12"
          sm="10"
          md="6"
          lg="5"
        >
          <div class="title mb-md-5 mb-4 mt-5 text-center">
            {{ $t('changePass') }}
          </div>
          <UserChangePasswordForm />
        </VCol>
      </VRow>
    </VCol>
  </VRow>
</template>

<script>
import UserInfoForm from '@/forms/UserInfoForm.vue';
import ValidationMixin from '@/mixins/ValidationMixin';
import UserChangePasswordForm from '@/forms/UserChangePasswordForm.vue';
import UserSettingsForm from '@/forms/UserSettingsForm.vue';

export default {
  name: 'AccountInfo',
  components: {
    UserSettingsForm,
    UserChangePasswordForm,
    UserInfoForm,
  },
  mixins: [ValidationMixin],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  holder: Account owner
  settings: Settings
  changePass: Change password
</i18n>

<i18n locale="ru" lang="yaml">
  holder: Владелец аккаунта
  settings: Настройки
  changePass: Изменение пароля
</i18n>
